package br.com.texeratx.boardgametimeapp.domain.usecases.upload

import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository

class UploadGameImageUseCase(
    private val repo: UploadRepository
) {
    suspend operator fun invoke(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> {
        return repo.uploadGameImage(bytes, fileName, mimeType)
    }
}
